import "./navbar.css";
import Logo from "../../images/logo.png";
import { Link } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { Avatar } from "antd";
export const EmpNav = () => {
//   const Posp = useSelector((state) => state?.posp?.Posp);
  return (
    <header className="bg-white w-100 d-block" style={{ padding: "5px 0px" }}>
      <div className="container d-flex justify-content-between align-items-center">
        <Link to="/" className="text-decoration-none">
          <img
            src={Logo}
            className="navbar-brand mt-0 position-relative"
            style={{ maxWidth: "150px" }}
            alt=""
          />
        </Link>
        {/* {Posp ? (
          <ul className="navbar-nav mb-2 mb-lg-0 gap-3 px-2">
            <li className="dropdown">
              <div className="d-flex align-items-center cursor-pointer">
                <Avatar
                  size={24}
                  style={{
                    backgroundColor: "#273592",
                    color: "#fff",
                  }}
                >
                  {Posp?.name[0] ?? "U"}
                </Avatar>{" "}
                <p className="mb-0 ms-2">{Posp?.name}</p>
              </div>
            </li>
          </ul>
        ) : null} */}
      </div>
    </header>
  );
};
